// src/composables/useAsyncGuard.ts
import { ref } from 'vue'

/**
 * Wraps an async action so it can't be invoked again while already in flight.
 * Exposes a single `isPending` ref for binding to :loading / :disable on the trigger button.
 */
export function useAsyncGuard() {
  const isPending = ref(false)

  const guard = <Args extends unknown[], R>(fn: (...args: Args) => Promise<R>) => {
    return async (...args: Args): Promise<R | undefined> => {
      if (isPending.value) return undefined // already running — swallow the duplicate tap
      isPending.value = true
      try {
        return await fn(...args)
      } finally {
        isPending.value = false
      }
    }
  }
  return { isPending, guard }
}
